module.exports = __webpack_public_path__ + "img/attraction-3-full.bad37c97.jpg";